import React, {Component} from 'react';
import {
	Button,
	Card,
	CardBody,
	CardSubtitle,
	CardTitle,
	Col,
	Collapse,
	Form,
	FormGroup,
	Input,
	Label,
	Row
} from 'reactstrap';
import {ACTIVE, BLOCKED, GUEST, NOT_APPROVED, STOREMODALVIEWS} from '../../helpers/constants';
import storeValidator from '../../helpers/storeValidator';
import {updateStoreAttributes} from '../../actions/attributesActions';
import {connect} from 'react-redux';
import profilephoto from '../../assets/images/users/1.jpg';
import 'react-table/react-table.css';
import './store.css';
import {closeAlert} from '../../actions/commonsActions';
import AttributesList from '../AttributesList/AttributesList';
import {fetchStores} from '../../actions/storesActions';
import {I18n} from '../../I18n/components/store';
import Select from 'react-select';
import MultipleOperatorSelector from "./MultipleOperatorSelector";
import Datetime from "react-datetime";
import moment from "moment/moment";

const daysOfWeek = [
	"MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"
];

class Store extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedStore: {
				countryCode: null,
				geonameId: null,
				address: '',
				latitude: null,
				longitude: null,
				schedule: [],
				bundleIds: [],
				operatorIds: []
			},
			countries: [],
			cities: [],
			editMode: false,
			isFormValid: false,
			isScheduleOpen: false,
		};
		this.validators = storeValidator;
	}

	componentDidMount() {
		Object.keys(this.validators).forEach(elem => {
			this.validators[elem].errors = [];
			this.validators[elem].state = '';
			this.validators[elem].valid = false;
		});
		const selectedStore = {...this.props.data};

		if (this.props.view === STOREMODALVIEWS.NEW)
			selectedStore.bundleIds = this.props.packages.map(type => type.id);

		if(!selectedStore.operatorIds)
			selectedStore.operatorIds = []

		this.setState({
			selectedStore,
			//selectedStore: {...this.props.data},
			countries: this.props.countries,
			cities: this.props.cities,
			isFormValid:  this.props.view === STOREMODALVIEWS.NEW ? false :  true
		})

	}

	updateStoreAttributesList = async attributes => {
        if (!attributes) {
            this.handleSubmit()
        } else {
            await this.props.updateStoreAttributes(attributes);
            await this.props.fetchStores({
                companyId: this.state.selectedStore.vendor.companyId || false
            });
            setTimeout(() => {
                this.props.closeAlert();
            }, 3000);
        }
	};

	handleSubmit = event => {
        if (event) {
            event.preventDefault();
        }
		if (this.props.view === STOREMODALVIEWS.NEW) {
			this.props.createStore(this.state.selectedStore)
		} else {
			this.props.updateStore(this.state.selectedStore)
		}
	};

	onInputChange = event => {
		let name, value;
		if (event && event.value && typeof event.value === "string") {
			name = 'countryCode';
			value = event.value;
		} else if (event && event.value && typeof event.value === "number") {
			name = 'cityGeonameId';
			value = event.value;
		} else {
			name = event.target.name;
			value = event.target.value;
		}
		this.onFieldChange(name, value);
	};

	onFieldChange = (name, value) => {
		this.setState(state => ({
			editMode: true,
			selectedStore: Object.keys(state.selectedStore).reduce((res, key) => {
				if (key === name) {
					let tempValue = [];
					if (Array.isArray(state.selectedStore[key])) {
						tempValue = value.split(',');
						tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
					} else {
						tempValue = value;
					}
					res[key] = tempValue; //(Array.isArray(state.newAttribute[key])) ? value.split(',') : value;
				} else {
					res[key] = state.selectedStore[key];
				}
				return res
			},{})
		}), () => {
			Object.keys(this.state.selectedStore).forEach(field => {
				if (this.validators[field]) {
					this.formValidators(field, this.state.selectedStore[field]);
				}
			});
			this.isFormValid();
		});
	}

	onScheduleChange = async (dayOfWeek, key, momentValue) => {
		const {selectedStore} = this.state;
		if (!selectedStore) {
			return;
		}
		const value = moment(momentValue).format("HH:mm");
		const newSchedule = selectedStore.schedule ? [...selectedStore.schedule] : [];
		const existedDaySchedule = newSchedule.find(s => s.dayOfWeek === dayOfWeek);
		if (existedDaySchedule) {
			existedDaySchedule[key] = value;
		} else {
			newSchedule.push({dayOfWeek: dayOfWeek, [key]: value});
		}
		selectedStore.schedule = newSchedule;
		await this.setState({selectedStore});
	};

	onScheduleClear = async (dayOfWeek, key) => {
		const {selectedStore} = this.state;
		selectedStore.schedule = selectedStore.schedule.map(s => s.dayOfWeek === dayOfWeek ? {...s, [key]: null} : s)
			.filter(s => s.openingTime || s.closingTime);
		await this.setState({selectedStore});
	};

	onPackagesItemChange = packageIds => {
		console.log(packageIds);
		const selectedStore = {...this.state.selectedStore};
		const concatedMultiplePackageIds = packageIds.reduce((res, elem) => {
			if (Array.isArray(elem)) {
				res = res.concat(elem);
			} else {
				res.push(elem);
			}
			return res;
		}, []);
		selectedStore.bundleIds = [...concatedMultiplePackageIds];
		this.setState({
			selectedStore
		});
	};

	onOperatorsItemChange = operatorIds => {
		console.log(operatorIds);
		const selectedStore = {...this.state.selectedStore};
		const concatedMultipleOperatorIds = operatorIds.reduce((res, elem) => {
			if (Array.isArray(elem)) {
				res = res.concat(elem);
			} else {
				res.push(elem);
			}
			return res;
		}, []);
		selectedStore.operatorIds = [...concatedMultipleOperatorIds];
		this.setState({
			selectedStore
		});
	};

	formValidators = (fieldName, value) => {
		this.validators[fieldName].errors = [];
		this.validators[fieldName].state = value;
		this.validators[fieldName].valid = true;
		this.validators[fieldName].rules.forEach(rule => {
			if (rule.test instanceof RegExp) {
				if (!rule.test.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			} else if (typeof rule.test === 'function') {
				if (!rule.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			}

		});
	};

	isFormValid = () => {
		let status = true;
		Object.keys(this.validators).forEach(field => {
			if (!this.validators[field].valid) {
					status = false;
			}
		});
		this.setState({
			isFormValid: status
		})
	};

	showErrors = fieldName => {
		const validator = this.validators[fieldName];
		const result = '';
		if (validator && !validator.valid) {
			const errors = validator.errors.map((info, index) => {
				return (
					<span className="error" key={index}>
           			 	* {info}
						<br/>
          			</span>
				);
			});

			return <div className="error mb-2">{errors}</div>;
		}
		return result;
	};

	renderCountrySelect = () => {
		const options = this.state.countries.map(elem => (
			{value: elem.countryCode, label: elem.countryName}
		));
		let label = '';
		const activeCountry = this.state.countries.find(elem =>
			elem.countryCode === this.state.selectedStore.countryCode
		);
		if (activeCountry) {
			label = activeCountry.countryName;
		}
		return (
			<Select
				isDisabled={true}
				name="countryCode"
				closeMenuOnSelect={true}
				value={{value: this.state.selectedStore.countryCode, label: label}}
				options={options}
				onChange={data => {
					this.updateCountry(data);
					this.onInputChange(data);
				}}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, { data }) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	renderCitySelect = () => {
		const options = this.state.cities.map(elem => (
			{value: elem.geonameId, label: elem.name}
		));
		let label = '';
		const activeCity = this.state.cities.find(elem =>
			elem.geonameId === this.state.selectedStore.cityGeonameId
		);
		if (activeCity) {
			label = activeCity.name;
		}
		return (
			<Select
				name="cityGeonameId"
				closeMenuOnSelect={true}
				value={{value: this.state.selectedStore.cityGeonameId, label: label}}
				options={options}
				onChange={data => {
					this.onInputChange(data);
				}}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, { data }) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	renderSchedule = () => {
		const {lang} = this.props;
		const {selectedStore} = this.state;
		const schedule = selectedStore.schedule;
		return daysOfWeek.map((day) => {
			const daySchedule = schedule && schedule.find(s => s && s.dayOfWeek === day)
				|| {dayOfWeek: day, salesPointId: selectedStore.id};
			return (
				<Row>
					<Col xs="12" md="12" lg="2" className="align-self-center">{I18n[lang].dayOfWeek[day.toLowerCase()]}</Col>
					<Col xs="12" md="12" lg="5" className="my-1">
						{this.renderDateTime(daySchedule, "openingTime")}
					</Col>
					<Col xs="12" md="12" lg="5" className="my-1">
						{this.renderDateTime(daySchedule, "closingTime")}
					</Col>
				</Row>
			);
		});
	}

	renderDateTime = (daySchedule, key) => {
		const dayOfWeek = daySchedule.dayOfWeek;
		const time = daySchedule[key];
		return (
			<div className="d-flex gap-1">
				<Datetime
					dateFormat={false}
					timeFormat="HH:mm"
					timeConstraints={{minutes: {step: 5}}}
					value={time ? moment(time, "HH:mm") : ""}
					onChange={value => this.onScheduleChange(dayOfWeek, key, value)}
					inputProps={{placeholder: "HH:mm", readOnly: true, style: {backgroundColor: "white"}}}
				/>
				<Button
					color="danger"
					className="ml-2"
					onClick={() => this.onScheduleClear(dayOfWeek, key)}
				>
					<i className="fa fa-times"/>
				</Button>
			</div>
		)
	}

	renderPackagesSelect = () => {
		const allOption = this.props.packages.reduce((result, item) => {
			result.value.push(item.id);
			return result;
		}, {value: [], label: I18n[this.props.lang].all});

		const options = this.props.packages.map(item => (
			{value: item.id, label: item.name}
		));
		options.unshift(allOption);

		const defaultValue = options.reduce((values, item) => {
			if (this.state.selectedStore.bundleIds.includes(item.value)) {
				values.push({
					value: item.value,
					label: item.label
				});
			}
			return values;
		}, []);
		return (
			<Select
				name="bundleIds"
				closeMenuOnSelect={true}
				value={defaultValue}
				options={options}
				isMulti
				isSearchable={false}
				onChange={data => {
					const result = data.map(type => type.value);
					this.onPackagesItemChange(result);
				}}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, { data }) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	toggleSchedule = () => this.setState({isScheduleOpen: !this.state.isScheduleOpen});

	render() {
		const {lang} = this.props;
		const {isScheduleOpen} = this.state;
		if (!this.state.selectedStore) {
			return <div>Loading...</div>;
		} else {
			return (
				<div>
					<Row>
						<Col xs="12" md="12" lg="3">
							<Card>
								<CardBody>
									<div className="text-center mt-4">
										<img src={profilephoto} className="rounded-circle" width="150" alt="" />
										<CardTitle className="mt-2 user-modal__name">{this.state.selectedStore.name}</CardTitle>
										<CardSubtitle></CardSubtitle>
									</div>
								</CardBody>
								<CardBody className="border-top">
									<div>
										<small className="text-muted">{I18n[lang].status}</small>
										<h6>{this.state.selectedStore.status || 'none'}</h6>
									</div>
								</CardBody>
							</Card>
						</Col>
						<Col xs="12" md="12" lg="9">
							<Card>
								<CardBody>
									<Form onSubmit={this.handleSubmit} className='new-attr__form'>
										<Row>
											<Col xs="12" md="12" lg="12">
												<Input type="hidden" name="id" id="id" defaultValue={this.state.selectedStore.id} />
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="12">
												<FormGroup>
													<Label for="name">{I18n[lang].name}</Label>
													<Input
														type="text"
														name="name"
														id="name"
														defaultValue={this.state.selectedStore.name}
														onChange={this.onInputChange}
														required
													/>
													{this.showErrors('name')}
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="role">{I18n[lang].country}</Label>
													{this.renderCountrySelect()}
													{this.showErrors('countryCode')}
												</FormGroup>
											</Col>
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="city">{I18n[lang].city}</Label>
													{this.renderCitySelect()}
													{this.showErrors('cityGeonameId')}
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="12">
												<FormGroup>
													<Label for="address">{I18n[lang].address}</Label>
													<Input
														type="text"
														name="address"
														id="address"
														defaultValue={this.state.selectedStore.address}
														onChange={this.onInputChange}
													/>
													{this.showErrors('address')}
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="latitude">{I18n[lang].latitude}</Label>
													<Input
														type="text"
														name="latitude"
														id="latitude"
														placeholder="12.0123456789"
														defaultValue={this.state.selectedStore.latitude}
														onChange={this.onInputChange}
													/>
													{this.showErrors('latitude')}
												</FormGroup>
											</Col>
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="longitude">{I18n[lang].longitude}</Label>
													<Input
														type="text"
														name="longitude"
														id="longitude"
														placeholder="12.0123456789"
														defaultValue={this.state.selectedStore.longitude}
														onChange={this.onInputChange}
													/>
													{this.showErrors('longitude')}
												</FormGroup>
											</Col>
										</Row>
										<Row className="cursor-pointer" onClick={this.toggleSchedule}>
											<Col xs="12" md="12" lg="12">
												{I18n[lang].schedule}
												<i className={"fa ml-2 fa-chevron-" + (isScheduleOpen ? "up" : "down")}></i>
											</Col>
										</Row>
										<Collapse isOpen={isScheduleOpen}>
											<Row>
												<Col xs="12" md="12" lg="2"></Col>
												<Col xs="12" md="12" lg="5">{I18n[lang].openingTime}</Col>
												<Col xs="12" md="12" lg="5">{I18n[lang].closingTime}</Col>
											</Row>
											{this.renderSchedule()}
										</Collapse>
										<Row className="mt-3">
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="status">{I18n[lang].status}</Label>
													<Input
														type="select"
														name="status"
														id="status"
														value={this.state.selectedStore.status}
														onChange={this.onInputChange}
													>
														<option value=""></option>
														<option value={NOT_APPROVED}>{I18n[lang].statusPending}</option>
														<option value={ACTIVE}>{I18n[lang].statusActive}</option>
														<option value={BLOCKED}>{I18n[lang].statusBlocked}</option>
													</Input>
												</FormGroup>
											</Col>
											<Col xs="12" md="12" lg="6">
												<FormGroup>
													<Label for="packages">{I18n[lang].activePackages}</Label>
													{this.renderPackagesSelect()}
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="12">
												<FormGroup>
													<Label for="operators">{I18n[lang].operatorCompanies}</Label>
													<MultipleOperatorSelector
														name="operators"
														operators={this.props.operatorTinyCompanies}
														operatorIds={this.state.selectedStore.operatorIds}
														onOperatorsItemChange={this.onOperatorsItemChange}
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="6">
												<FormGroup className='new-attr__buttons'>
													<Button
														color="primary"
														type="button"
														onClick={this.props.getCompanyUsers}
                                                        // disabled={this.props.view === STOREMODALVIEWS.NEW ? true :  false}
													>
														{I18n[lang].addMember}
													</Button>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col xs="12" md="12" lg="6">
												<FormGroup className='new-attr__buttons'>
													<Button
														color="danger"
														type="button"
														onClick={() => {this.props.getMembers(this.state.selectedStore)}}
                                                        // disabled={this.props.view === STOREMODALVIEWS.NEW ? true :  false}
													>
														{I18n[lang].delMember}
													</Button>
												</FormGroup>
											</Col>
										</Row>
										{
                                            this.props.view === STOREMODALVIEWS.EDIT &&
                                            this.state.selectedStore.attributes && this.state.selectedStore.attributes.length ? "" :
												(
                                                    <Row>
                                                        <Col xs="12" md="12" lg="12">
                                                            <FormGroup className='new-attr__buttons'>
                                                                <Button color="secondary" className="ml-1" onClick={this.props.closeModal}>{I18n[lang].cancel}</Button>
                                                                <Button color="primary" className={`${
                                                                    this.state.isFormValid ? '' : 'disabled'}`} type="submit">{I18n[lang].save}</Button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
												)
										}

									</Form>
									{
										this.props.view === STOREMODALVIEWS.EDIT &&
										this.state.selectedStore.attributes && this.state.selectedStore.attributes.length ? (
											<div className="store__attributes">
												<CardSubtitle>{I18n[lang].tt_attributes}</CardSubtitle>
												<AttributesList
													attributes={this.state.selectedStore.attributes ? this.state.selectedStore.attributes : []}
													isAttributesChangingAllowed={true}
													updateAttributesList={this.updateStoreAttributesList}
													authority={this.props.authority}
													close={this.props.closeModal}
												/>
											</div>
										) : ""
									}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>

			);
		}
	}
}

const mapDispatchToProps = dispatch => {
	return {
		fetchStores: query => dispatch(fetchStores(query)),
		updateStoreAttributes: attributes => dispatch(updateStoreAttributes(attributes)),
		closeAlert: () => dispatch(closeAlert())
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	currentUser: state.currentUser,
	authority:  state.currentUser.roles[0].authority || GUEST,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Store)



// WEBPACK FOOTER //
// ./src/components/Store/Store.js